export default function setAgentPreferences(context, preferences) {
  context.stores.agentPreferences.set(preferences);
  context.stores.agentPreferencesLocal.set(preferences);
}
